import React, { useState, useEffect } from "react";
import "./GradientLogo.scss";

const GradientLogo = ({ onToggle }) => {
  const [position, setPosition] = useState({ top: "70%", right: "3vw" });

  useEffect(() => {
    const randomTop = Math.random() * 80 + 10; // 10% to 90%
    const randomRight = Math.random() * 85 + 5; // 5% to 90%
    setPosition({
      top: `${randomTop}%`,
      right: `${randomRight}%`,
    });
  }, []);

  return (
    <div
      className="gradient-logo-container"
      style={position}
      onClick={onToggle}
    >
      <img
        src={require("../assets/gradient-dot_500.png")}
        alt="Gradient Logo"
      />
    </div>
  );
};

export default GradientLogo;
